import React from 'react'
import { AlertTriangle } from 'lucide-react'
import { Button } from '@/common/ui/button'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogFooter,
} from '@/common/ui/dialog'

interface WheelSetupModalProps {
	isOpen: boolean
	onClose: () => void
}

export default function WheelSetupModal({
	isOpen,
	onClose,
}: WheelSetupModalProps) {
	return (
		<Dialog open={isOpen} onOpenChange={onClose}>
			<DialogContent className="sm:max-w-[600px]">
				<DialogHeader className="pb-4">
					<DialogTitle className="flex items-center gap-2 text-xl">
						<AlertTriangle className="h-6 w-6 text-amber-500" />
						คำแนะนำการตั้งค่ากงล้อ
					</DialogTitle>
				</DialogHeader>

				<div className="space-y-6">
					{/* Main instruction */}
					<div className="rounded-lg border-2 border-amber-200 bg-amber-50 p-4">
						<h3 className="mb-3 flex items-center gap-2 text-lg font-semibold text-amber-800">
							<AlertTriangle className="h-5 w-5" />
							ข้อสำคัญ
						</h3>
						<p className="leading-relaxed text-amber-800">
							การเซ็ตรางวัลต้องตรงกับรูปภาพ เริ่มจาก{' '}
							<span className="font-semibold">12 นาฬิกา</span> และหมุนตาม
							<span className="font-semibold">เข็มนาฬิกา</span>
						</p>
					</div>

					{/* Example */}
					<div className="rounded-lg border border-gray-200 bg-gray-50 p-4">
						<h3 className="mb-3 text-lg font-semibold text-gray-800">
							ตัวอย่าง
						</h3>
						<div className="space-y-2 text-gray-700">
							<p>
								หากรางวัล{' '}
								<span className="font-semibold text-blue-600">1000 บาท</span>{' '}
								อยู่ที่ตำแหน่ง <span className="font-semibold">12 นาฬิกา</span>{' '}
								ในรูปภาพ
							</p>
							<p>
								→ ต้องใส่รางวัล{' '}
								<span className="font-semibold text-blue-600">1000 บาท</span>{' '}
								เป็น<span className="font-semibold">ลำดับแรก</span>ในรายการ
							</p>
							<p>→ จากนั้นเรียงรางวัลถัดไปตามเข็มนาฬิกา</p>
							<div className="mt-3 text-sm text-gray-600">
								(12 นาฬิกา → 1 นาฬิกา → 2 นาฬิกา → 3 นาฬิกา...)
							</div>
						</div>
					</div>

					{/* Warning */}
					<div className="rounded-lg border-2 border-red-200 bg-red-50 p-4">
						<div className="flex items-start gap-3">
							<AlertTriangle className="mt-0.5 h-5 w-5 flex-shrink-0 text-red-500" />
							<div>
								<h3 className="mb-1 font-semibold text-red-800">คำเตือน</h3>
								<p className="text-red-700">
									หากตั้งค่าไม่ตรงกับรูปภาพ ผลการหมุนจะไม่แม่นยำ
								</p>
							</div>
						</div>
					</div>
				</div>

				<DialogFooter className="pt-6">
					<Button onClick={onClose} className="h-12 w-full text-base">
						เข้าใจแล้ว ดำเนินการต่อ
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	)
}
